var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ShowIf from '../../util/ShowIf';
export const Stack = (_a) => {
    var { spacing = 1, base = 8, unit = 'px', className = undefined, children } = _a, props = __rest(_a, ["spacing", "base", "unit", "className", "children"]);
    const computedMargin = `${spacing * base}${unit}`;
    return (_jsx("div", Object.assign({ className: [...['o-stack'], className !== null && className !== void 0 ? className : ''].filter((s) => s && s.length > 0).join(' ') }, props, { children: React.Children.map(children, (child, index) => (_jsx(ShowIf, Object.assign({ condition: child !== null }, { children: _jsx("div", Object.assign({ style: { marginTop: index === 0 ? '0' : computedMargin } }, { children: child }), index) })))) })));
};
export default Stack;
